module.exports = __webpack_public_path__ + "img/web3.0ce0c9b9.png";